import config from "config/config"
import axios from "axios"
import * as url from "../helpers/url_helper"

export const promotionRequestsApi = {
  getRequests: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.GET_PROMOTION_REQUESTS}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },

  performAction: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.POST_PROMOTION_ACTION}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    }
    return await axios(axiosConfig)
  },

  exportRequests: async data => {
    var axiosConfig = {
      method: "POST",
      url: `${config.API_URL}${url.EXPORT_PROMOTION_REQUESTS}`,
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
      data,
    }
    return await axios(axiosConfig)
  },
}
